export default "__VITE_ASSET__BBnz3ZAn__"